<div v-if="options">
	<section v-if="hasMoreThanFourReferralPoints">
		<p>{{ $tc('vm.components.popin.referral-convert-point.text.text1', options.point, { points: options.point , months: options.months }) }}</p>
		<p>{{ $t('vm.components.popin.referral-convert-point.text.text5') }}</p>
		<p>{{ $tc('vm.components.popin.referral-convert-point.text.text6', remainingPoint,{ count: remainingPoint }) }}</p>
		<p>{{ $t('vm.components.popin.referral-convert-point.text.text7') }}</p>
		<p>{{ $t('vm.components.popin.referral-convert-point.text.text8') }}</p>

	</section>
    <section v-else>
		<p>{{ $tc('vm.components.popin.referral-convert-point.text.text1', options.point, { points: options.point , months: options.months }) }}</p>
		<p>{{ $t('vm.components.popin.referral-convert-point.text.text2') }}</p>
		<p>{{ $t('vm.components.popin.referral-convert-point.text.text3') }}</p>
		<p>{{ $t('vm.components.popin.referral-convert-point.text.text4') }}</p>

	</section>
</div>
